import React, { useContext } from 'react';
import { string } from 'prop-types';
import {
  number as numberType,
  params,
  shape as shapeType,
  string as stringType
} from '@thd-nucleus/data-sources';
import { useProductDeprecated } from '@thd-nucleus/data-sources/react/dataModel/migration';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { LoadingPlaceholder } from '@thd-olt-component-react/loading-placeholder';
import { IntroOffer } from './IntroOffer.component';
import { PaymentEstimator } from './paymentEstimator/PaymentEstimator.component';

export const ConsumerCardMessaging = ({ itemId, paymentEstimatorVersion }) => {
  const experienceContext = useContext(ExperienceContext);
  const { channel } = experienceContext;
  const { data, error, loading } = useProductDeprecated({ itemId, domains: ['pricing'] });
  // const { data, error, loading } = useDataModel('product', { variables: { itemId } });

  if (error && !data && !loading) {
    return null;
  }

  if (loading) {
    return (
      <LoadingPlaceholder
        type="text"
        ready={false}
        color="#E0E0E0"
        rows={2}
        showLoadingAnimation
      >
        Loading...
      </LoadingPlaceholder>
    );
  }

  const pricing = data?.product?.pricing;
  if (!pricing) return null;

  const { value } = pricing;
  return value >= 299.00
    ? <PaymentEstimator price={`${value}`} mobile={channel === 'mobile'} fileVersion={paymentEstimatorVersion} />
    : <IntroOffer mobile={channel === 'mobile'} fileVersion={paymentEstimatorVersion} />;
};

ConsumerCardMessaging.displayName = 'ConsumerCardMessaging';

ConsumerCardMessaging.dataModel = {
  product: params({
    itemId: stringType().isRequired()
  }).shape({
    pricing: shapeType({
      value: numberType()
    })
  })
};

ConsumerCardMessaging.propTypes = {
  itemId: string.isRequired,
  paymentEstimatorVersion: string
};

ConsumerCardMessaging.defaultProps = {
  paymentEstimatorVersion: 'v1.0.16'
};
